import { wxPhoneNumber } from '@/api'
import { getStorage , setStorage  } from "@/utils/storage";

export default {
	state: {
    sessionKey:getStorage('SESSION_KEY') ||'',
    lastPostion:null
	},
	mutations: {
    SET_SESSION_KEY(state, sessionKey) {
      setStorage("SESSION_KEY",sessionKey)
      state.sessionKey = sessionKey
    },
	},
	actions: {
    async wxLoginCode(){
      return new Promise((resolve,reject)=>{

        resolve(1)
        // resolve(2)
        // resolve('1762324277396246530')




      })
    },
    async getWxPhoneNumber({dispatch},res){




      return '15800804609'

    },
    async authorizeLocation(){



























    },
    async chooseLocation({dispatch},{latitude,longitude}={}){

















      return{
        name:'测试地址',
        address:'测试地址描述',
        latitude:27.552079,
        longitude:109.982736,
      }

    },
    async getLocation({state,dispatch}, params={}){






































        return new Promise((resolve,reject)=>{
          setTimeout(()=>{
            resolve({
              lng:109.982736,
              lat:27.552079
            })
          },200)
        })

    }
	}
}
